export enum FormRequestName {
  createVersion = 'createVersion',
  createSubmission = 'createSubmission',
}

export type FormRequestNameType = keyof typeof FormRequestName;
